import { orderBy, QueryConstraint, where } from 'firebase/firestore';
import { FeedFilter } from '../interactors/get-team-feed.interactor';
import { UnreachableCaseError } from '@uploadcam/common';

export function createFeedQuery(teamId: string, filter?: FeedFilter): QueryConstraint[] {
  const feedQuery: QueryConstraint[] = [where('teamId', '==', teamId)];

  if (filter) {
    (Object.keys(filter) as (keyof FeedFilter)[]).forEach((key) => {
      switch (key) {
        case 'uploadedBy': {
          const value = filter[key];

          if (value) {
            feedQuery.push(where('uploadedBy', '==', value));
          }
          break;
        }
        case 'albumId': {
          const value = filter[key];

          if (value) {
            feedQuery.push(where('albumId', '==', value));
          }
          break;
        }
        case 'folder': {
          const value = filter[key];

          if (value) {
            feedQuery.push(where('folderId', '==', value.id));
          }
          break;
        }
        case 'afterDate': {
          const value = filter[key];

          if (value) {
            const afterDate = new Date(value);
            afterDate.setHours(0, 0, 0, 0);
            feedQuery.push(where('createdAt', '>=', afterDate));
          }
          break;
        }
        case 'beforeDate': {
          const value = filter[key];

          if (value) {
            const beforeDate = new Date(value);
            beforeDate.setHours(23, 59, 59, 999);
            feedQuery.push(where('createdAt', '<=', beforeDate));
          }
          break;
        }
        case 'geoBBox': {
          const value = filter[key];

          if (value) {
            feedQuery.push(where('metadata.latitude', '>=', value.south));
            feedQuery.push(where('metadata.latitude', '<=', value.north));
            feedQuery.push(where('metadata.longitude', '>=', value.west));
            feedQuery.push(where('metadata.longitude', '<=', value.east));
          }
          break;
        }
        case 'tags': {
          const value = filter[key];

          if (value && value.length > 0) {
            feedQuery.push(where('tags', 'array-contains-any', [...value]));
          }
          break;
        }
        default: {
          throw new UnreachableCaseError(key);
        }
      }
    });
  }

  // Sorting
  feedQuery.push(orderBy('createdAt', 'desc'));

  if (filter?.geoBBox) {
    feedQuery.push(orderBy('metadata.latitude', 'asc'));
    feedQuery.push(orderBy('metadata.longitude', 'asc'));
  }

  return feedQuery;
}
